/**
 * Fix for date picker not showing when clicked
 */
(function() {
  // Run after DOM is loaded
  window.addEventListener('DOMContentLoaded', () => {
    // Find all date inputs in the document
    const dateInputs = document.querySelectorAll('input[type="date"]');
    
    // Add click handlers to each date input
    dateInputs.forEach(input => {
      input.addEventListener('click', function(e) {
        // Prevent default behavior, which might be blocked
        e.stopPropagation();
        
        // Try to manually show the date picker
        try {
          this.showPicker();
        } catch (error) {
          console.log('Failed to show date picker with showPicker()', error);
          
          // Fallback for older browsers
          const event = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          });
          
          // Re-dispatch the event
          this.dispatchEvent(event);
        }
      });
    });
  });
  
  // Also handle dynamically added date inputs
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          // Check if the added node is an element and contains date inputs
          if (node.nodeType === 1) {
            const dateInputs = node.querySelectorAll('input[type="date"]');
            
            dateInputs.forEach(input => {
              input.addEventListener('click', function(e) {
                e.stopPropagation();
                try {
                  this.showPicker();
                } catch (error) {
                  console.log('Failed to show date picker for dynamically added input', error);
                }
              });
            });
          }
        });
      }
    });
  });
  
  // Start observing the document with the configured parameters
  observer.observe(document.body, { childList: true, subtree: true });
})(); 